"use client"
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from 'react-bootstrap';
import {hardGray, hover, softWhite, text, white} from '@/styles/globalStyleVars';
import SocialShare from "@/components/common/SocialShare";
import {usePathname} from "next/navigation";
import Button from "@/components/common/ui/Button";
import {Img} from "@/components/common/ui/Img";
import VideoDetails from "@/components/details/VideoDetails";
import {gsap} from "gsap";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";
import reactHtmlParser from "react-html-parser";
import {useGSAP} from "@gsap/react";
import KeyPopUp from "@/components/common/forms/KeyPopUP";

const Details = ({data}) => {

    const detailsRef = useRef();

    const location = usePathname();



    const leftWrapperRef = useRef(null);
    useGSAP(() => {
        const col4Element = document.querySelector('.social-pin-wrapper');
        const rightWrapperElement = document.querySelector('.details__right');

        if (window.innerWidth >= 768) { // Apply pinning only for non-mobile devices
            gsap.to(col4Element, {
                scrollTrigger: {
                    trigger: col4Element,
                    start: 'top +160',
                    end: () => `+=${rightWrapperElement.scrollHeight - 100}`,
                    pin: true,
                    pinSpacing: false
                }
            });
        }
    }, [data]);

    const isMobile = useDeviceTypeTab();

    var date = new Date(data?.data?.data?.date);

    // Extract day, month, and year
    var day = date.getDate();
    var month = date.toLocaleString('default', {month: 'long'});
    var year = date.getFullYear();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);


    };
    return (
        <StyledDetails className="details-wrapper">
            <KeyPopUp show={show} handleClose={handleClose}/>

            <Container>
                <Row ref={detailsRef}>
                    {
                        isMobile ?
                            <Col md={12} className={'forMobile'}>
                                <div ref={leftWrapperRef} className="mobilefooter ">
                                    <SocialShare/>
                                    <Button onClick={handleShow} text={'Apply with Maximus'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>

                                </div>
                            </Col>
                            : ''
                    }
                    <Col md={{span: 3}}>
                        <div ref={leftWrapperRef} className="social-pin-wrapper ">
                            {
                                !isMobile ?
                                    <div className="social-wrapper-main">
                                        <SocialShare/>
                                        <Button onClick={handleShow} text={'Apply with Maximus'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>
                                    </div>
                                    :
                                    ''
                            }
                        </div>

                    </Col>

                    <Col md={{span: 8, offset: 1}} className={'details__right'} ref={detailsRef}>
                        <div className="intro ">
                            <div className="intro-left">
                                {
                                    data?.data?.data?.title &&
                                    <h1>{reactHtmlParser(data?.data?.data?.title)}</h1>

                                }
                            </div>
                        </div>
                        <div className="breadcump">
                            {
                                data?.data?.category?.title &&
                                <p className={'split-up'}>{reactHtmlParser(data?.data?.category?.title)}</p>

                            }
                            {
                                month && day && year &&
                                <p className={'split-up'}>{month + ' ' + day + ', ' + year}</p>

                            }
                        </div>

                        {

                            data?.data?.images?.list?.length > 0 && data?.data?.images?.list?.find(f => f?.banner === 'on')?.full_path &&
                            <div className="banner-for-news">
                                <Img alt={data?.data?.data?.title} src={data?.data?.images?.list?.find(f => f?.banner === 'on')?.full_path}/>
                            </div>
                        }

                        {
                            data?.data?.data?.body &&
                           reactHtmlParser(data?.data?.data?.body)

                        }


                        {/*<h6><strong>[Colored Section Title] </strong>Where does it come from?</h6>*/}
                        {/*<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br/>*/}
                        {/*<ul className={'list-count two'}>*/}
                        {/*    <li className={'split-up'}><b>Gerontology</b>Receive personalized coaching based on your unique strengths and weaknesses.</li>*/}
                        {/*    <li className={'split-up'}><b>Rehabilitation Sciences</b>Enjoy the flexibility of choosing between group classes, one-on-one tutoring, or online sessions</li>*/}
                        {/*    <li className={'split-up'}><b>Leadership and Management</b>Benefit from regular practice tests that mimic the real exam environment, helping you become comfortable with the timing and format of the test</li>*/}
                        {/*    <li className={'split-up'}><b>Research and Evidence-Based Practice</b>Receive detailed feedback and scoring on practice tests, allowing you to track your progress and focus on areas that need improvement</li>*/}
                        {/*</ul>*/}
                        {/*<h6>[Section Title] What is Lorem Ipsum?</h6>*/}
                        {/*<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br/>*/}
                        {/*<ul className={'list-count two'}>*/}
                        {/*    <li className={'split-up'}>Receive personalized coaching based on your unique strengths and weaknesses.</li>*/}
                        {/*    <li className={'split-up'}>Enjoy the flexibility of choosing between group classes, one-on-one tutoring, or online sessions</li>*/}
                        {/*    <li className={'split-up'}>Benefit from regular practice tests that mimic the real exam environment, helping you become comfortable with the timing and format of the test</li>*/}
                        {/*    <li className={'split-up'}>Receive detailed feedback and scoring on practice tests, allowing you to track your progress and focus on areas that need improvement</li>*/}
                        {/*</ul>*/}
                        {/*<h4>Visa Details</h4>*/}
                        {/*<ul className={'list-course'}>*/}
                        {/*    <li>*/}
                        {/*        <h6>1. Requirements</h6>*/}
                        {/*        <p>Each visa category has specific eligibility requirements, including qualifications, work experience, language proficiency, health, and character requirements. This section provides detailed information on what you need to qualify for your chosen visa.</p>*/}
                        {/*    </li>*/}
                        {/*    <li>*/}
                        {/*        <h6>2. Requirements</h6>*/}
                        {/*        <p>Each visa category has specific eligibility requirements, including qualifications, work experience, language proficiency, health, and character requirements. This section provides detailed information on what you need to qualify for your chosen visa.</p>*/}
                        {/*    </li>*/}
                        {/*    <li>*/}
                        {/*        <h6>3. Requirements</h6>*/}
                        {/*        <p>Each visa category has specific eligibility requirements, including qualifications, work experience, language proficiency, health, and character requirements. This section provides detailed information on what you need to qualify for your chosen visa.</p>*/}
                        {/*    </li>*/}
                        {/*    <li>*/}
                        {/*        <h6>4. Requirements</h6>*/}
                        {/*        <p>Each visa category has specific eligibility requirements, including qualifications, work experience, language proficiency, health, and character requirements. This section provides detailed information on what you need to qualify for your chosen visa.</p>*/}
                        {/*    </li>*/}
                        {/*    <li>*/}
                        {/*        <h6>5. Requirements</h6>*/}
                        {/*        <p>Each visa category has specific eligibility requirements, including qualifications, work experience, language proficiency, health, and character requirements. This section provides detailed information on what you need to qualify for your chosen visa.</p>*/}
                        {/*    </li>*/}
                        {/*</ul>*/}

                        {/*<VideoDetails image={'/images/dynamic/common/video_details.jpg'} link={'TInGSRDtYAM'}/>*/}

                        {/*<table>*/}
                        {/*    <tbody>*/}
                        {/*    <tr>*/}
                        {/*        <td className={'split-up'}>Pre-degree qualifications</td>*/}
                        {/*        <td className={'split-up'}> $3,300 - $7,500 approx</td>*/}
                        {/*    </tr>*/}
                        {/*    <tr>*/}
                        {/*        <td className={'split-up'}>Undergraduate bachelor's degrees</td>*/}
                        {/*        <td className={'split-up'}>$7,797.60 - $13,632 approx. (based on 120 credits) (depending on the subject area)*/}
                        {/*        </td>*/}
                        {/*    </tr>*/}
                        {/*    <tr>*/}
                        {/*        <td className={'split-up'}>Graduate qualifications</td>*/}
                        {/*        <td className={'split-up'}>$6,500 - $9,000 approx.</td>*/}
                        {/*    </tr>*/}
                        {/*    <tr>*/}
                        {/*        <td className={'split-up'}>Postgraduate qualifications</td>*/}
                        {/*        <td className={'split-up'}>$8,226 - $13,960 approx.</td>*/}
                        {/*    </tr>*/}
                        {/*    </tbody>*/}
                        {/*</table>*/}

                        {/*<VideoDetails image={'/images/dynamic/common/video_details.jpg'} link={'TInGSRDtYAM'}/>*/}

                        {/*<blockquote>*/}
                        {/*    <p>[Block Quote] The journey to financial independence begins with a clear destination in mind. Setting meaningful financial goals provides the foundation for building wealth and creating a roadmap to success. By crafting a comprehensive plan tailored to your aspirations, you can turn your dreams into actionable steps.</p>*/}
                        {/*    <span>- John Smith</span>*/}
                        {/*</blockquote>*/}
                        {/*<div className="img-full">*/}
                        {/*    <div className="img-wrapper">*/}
                        {/*        <Img alt="details-full-image" src="https://bestinbd.com/projects/web/nile/html/assets/images/live/theme-version-01/blogs/details/blog_details_multi_column_large_image.jpg"/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="img-flex">*/}
                        {/*    <div className="img-flex__left">*/}
                        {/*        <div className="img-flex__left__wrapper">*/}
                        {/*            <Img alt="details-full-image" src="https://bestinbd.com/projects/web/nile/html/assets/images/live/theme-version-01/blogs/details/blog_details_multi_column_small_image_1.jpg"/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div className="img-flex__right">*/}
                        {/*        <div className="img-flex__right__wrapper">*/}
                        {/*            <Img alt="details-full-image" src="https://bestinbd.com/projects/web/nile/html/assets/images/live/theme-version-01/blogs/details/blog_details_multi_column_small_image_2.jpg"/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<ul className={'list-count two'}>*/}
                        {/*    <li className={'split-up'}>Receive personalized coaching based on your unique strengths and weaknesses.</li>*/}
                        {/*    <li className={'split-up'}>Enjoy the flexibility of choosing between group classes, one-on-one tutoring, or online sessions</li>*/}
                        {/*    <li className={'split-up'}>Benefit from regular practice tests that mimic the real exam environment, helping you become comfortable with the timing and format of the test</li>*/}
                        {/*    <li className={'split-up'}>Receive detailed feedback and scoring on practice tests, allowing you to track your progress and focus on areas that need improvement</li>*/}
                        {/*</ul>*/}
                    </Col>

                </Row>
            </Container>
        </StyledDetails>
    );
};

const StyledDetails = styled.section`
    padding: 200px 0 200px;
    background: ${softWhite};
    position: relative;
    @media (max-width: 767px) {
        padding: 80px 0 120px !important;
        .forMobile {
            padding: 0 !important;
            margin-bottom: 60px;

        }

        .social-list-wrap-div {
            padding: 0 15px;

        }

        .mobilefooter {
            .dc-btn {
                height: 60px;
                max-width: 100% !important;
                float: left;

                &.visit-btn {
                    a {
                        background: ${hover} !important;
                    }
                }

                a {
                    border-radius: 0 !important;
                    border: none;
                    background: ${text};
                    padding: 0 15px !important;
                    @media (max-width: 400px) {
                        font-size: 12px;
                        line-height: 18px;
                    }
                    &:before{
                        display: none !important;
                    }
                    span {
                        color: ${white} !important;
                    }

                }
            }
        }
    }
    .img-full {
        margin-bottom: 30px;
        position: relative;

        .global-image {
            border-radius: 10px;
        }

        .img-wrapper {
            position: relative;
            padding-top: calc(520 / 870 * 100%);
        }
    }

    .img-flex {
        display: flex;
        gap: 30px;
        position: relative;
        margin-bottom: 60px;

        @media (max-width: 767px) {
            flex-direction: column;
        }
        .global-image {
            border-radius: 10px;
        }

        .img-flex__left, .img-flex__right {
            width: 50%;
            @media(max-width: 767px){
                width: 100%;
            }
        }

        .img-flex__left__wrapper, .img-flex__right__wrapper {
            position: relative;
            padding-top: calc(250 / 420 * 100%);
        }
    }

    blockquote {
        border-left: 2px solid ${hover};
        padding-left: 20px;
        margin-bottom: 60px;

        span {
            margin-top: 40px;
            display: block;
        }

    }

    @media (max-width: 767px) {
        padding: 120px 0;
    }

    @media (min-width: 1024px) {
        .video-modal__img {
            padding-top: calc(326 / 870 * 100%);
        }
    }

    .caption {
        font-weight: 500;
        margin-top: 20px;
    }

    .mobilefooter {
        .dc-btn {
            max-width: 270px;
        }

        .social {
            align-items: flex-start !important;
            justify-content: flex-start !important;
        }
    }

    .video-modal {
        margin-bottom: 30px;
    }

    .caption {
        margin-bottom: 60px;
    }

    //introduction

    .breadcump {
        display: flex;
        width: 100%;
        margin-bottom: 20px;

        p {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            color: ${hardGray};
            position: relative;
            padding-right: 15px;

            &:after {
                content: '.';
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.16px;
                font-weight: 400;
                color: ${hardGray};
                position: absolute;
                top: -3px;
                right: -3px;
            }

            &:last-child {
                padding-right: 0;
                padding-left: 15px;

                &:after {
                    display: none;
                }
            }
        }
    }

    .banner-for-news {
        position: relative;
        padding-top: calc(480 / 870 * 100%);
        margin-bottom: 60px;

        .global-image {
            border-radius: 10px;
        }
    }

    .small-box-cta {
        margin-top: 20px;
    }

    //introduction

    .intro {
        margin-bottom: 30px;
        display: flex;

        &.border-bottom-new {
            border-bottom: 4px solid ${hover} !important;

        }

        .intro-left {
            flex: 0 0 100%;
            max-width: 100%;

            img {
                width: auto;
            }

            h1 {
                font-size: 32px;
                line-height: 40px;
                letter-spacing: -0.32px;
                font-weight: 500;
                color: ${text};
            }
        }

    }


    //banner

    .banner {
        margin-bottom: 60px;

        .campus {
            margin-bottom: 30px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;

            .campus-single {
                flex: 0 0 calc(33.333333% - 60px);
                max-width: calc(33.333333% - 60px);
                margin-right: 30px;

                &:last-child {
                    margin-right: 0;
                }

                h5 {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: -0.12px;
                    color: ${hardGray};
                    margin-bottom: 10px;
                }

                p {
                    color: ${text};
                    margin: 0;
                }
            }
        }

        .banner-wrapper {
            position: relative;
            padding-top: calc(480 / 870 * 100%);
            margin: 60px 0;

            .global-image {
                border-radius: 10px;
            }
        }
    }


    //course list

    .course-list-wrapper {
        margin-top: 30px;
        padding-bottom: 60px;
        border-bottom: 1px solid #040504;
        margin-bottom: 60px;

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 30px;
        }

        .course-list {

            display: flex;
            gap: 30px;
            flex-flow: wrap;
        }

        .course-single {
            flex: 0 0 calc(33.3333% - 30px);
            max-width: calc(33.3333% - 30px);
        }
    }

    //description

    .mb-bottom {
        margin-bottom: 60px;
    }

    .overview {
        p {
            line-height: 20px;

            a {
                color: ${hover};
                text-decoration: underline;
            }
        }
    }

    p {
        line-height: 20px;

        a {
            color: ${hover};
            text-decoration: underline;
        }
    }

    .detail-description {
        .nzuac-list-count {
            margin-bottom: 20px;

            span {
                display: block;
                font-weight: 500;
            }

            li {
                &:last-child {
                    &:before {
                        display: none;
                    }
                }
            }
        }

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 20px;
        }

        table {
            gap: 20px;
            margin-bottom: 60px;

            th {
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */
                color: ${text};
                border-top: none !important;
            }

            tr {
                border-bottom: 1px solid rgba(20, 38, 55, 0.2);
                justify-content: flex-start;
                padding: 20px 0;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */

                &:first-child {
                    border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                    padding-top: 0;
                }

                &:last-child {
                    border-bottom: none;
                }

                th {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }

                td {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }
            }
        }

        ul {
            margin-top: 0;
            margin-bottom: 60px;

            li {
                border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                font-size: 16px;
                font-weight: 400;

                strong {
                    font-weight: 500;
                }
            }
        }

        a {
            color: ${hover};
            margin-bottom: 20px;
            display: inline-block;
        }

        &.mb-bottom {
            a {
                color: ${hover};
                margin-top: 20px;
                display: inline-block;
            }
        }
    }

    .image-gallery-slider {
        position: relative;
        margin-bottom: 60px;

        .navigation {
            position: absolute;
            bottom: -35px;
            right: 0;
        }

        .img-wrapper-big {
            padding-top: calc(570 / 870 * 100%);
            position: relative;
        }

        .swiper-slide-active {
            p {
                transition-delay: 0.7s;
                opacity: 1;
            }
        }

        p {
            opacity: 0;
            transition: 0.7s all cubic-bezier(0.54, 0.32, 0.05, 0.96);
            max-width: 70%;
            margin-top: 35px;
            font-weight: 500;
        }
    }

    .video-modal {
        margin: 60px 0;

        .global-image {
            border-radius: 10px;
        }
    }

    h2, h3, h4, h5, h6 {
        margin-bottom: 20px;
    }

    .color-max {
        color: ${hover} !important;
    }

    //responsive
    @media (max-width: 992px) {
        .col-md-3 {
            display: none;
        }

        .col-md-8 {
            flex: 0 0 100%;
            max-width: 100%;
            margin: 0;
        }

        .course-list-wrapper {
            .course-single {
                max-width: calc(50% - 15px);
                flex: 0 0 calc(50% - 15px);
            }
        }
    }
    @media (max-width: 767px) {
        .intro {
            display: flex;
            align-items: flex-start;
            position: relative;

            .intro-left {
                flex: 0 0 100%;
                max-width: 100%;
            }

            .intro-right {
                flex: unset;
                max-width: unset;
                position: absolute;
                right: 0;
                top: 0;


                .box-wrapper {
                    position: unset;
                    padding-top: unset;
                    background: transparent;

                    .global-image {
                        display: none;
                    }

                    .content {
                        position: unset;
                        inset: unset;
                        padding: 0;

                        p {
                            color: #888888;

                            &.ranking {
                                color: ${hover};
                            }
                        }
                    }
                }
            }
        }

        .banner {
            .campus {
                flex-direction: column;

                .campus-single {
                    flex: 0 0 100%;
                    max-width: 100%;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .course-list-wrapper {
            .course-box {
                padding-top: calc(120 / 345 * 100%);
            }

            .course-single {
                max-width: 100%;
                flex: 0 0 100%;
            }
        }
    }
`;

export default React.memo(Details);




